// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"b6ba8fc6","213":"baa0378a","312":"25e60302","446":"d865c7c9","586":"8ebaf524","750":"fa949f37","844":"db7b2571","868":"b7e9ab16","875":"e882cd5c","978":"f68c3706"}[chunkId] + ".chunk.js";
};